import { FlowKind } from 'flow-schema';

import { SharedSubFlowV2BlockFormFields } from './SharedFormFields';

export function SubFlowFormFields() {
  return (
    <SharedSubFlowV2BlockFormFields
      fieldNamePrefix="config"
      variant="SubflowPicker"
      allowedFlowKinds={[FlowKind.Base]}
    />
  );
}
